import { render } from "./LessonsListing.vue?vue&type=template&id=acc65ea6&ts=true"
import script from "./LessonsListing.vue?vue&type=script&lang=ts"
export * from "./LessonsListing.vue?vue&type=script&lang=ts"

import "./LessonsListing.vue?vue&type=style&index=0&id=acc65ea6&lang=scss"

import exportComponent from "/Users/trend/MANARATFOUNDATION/KRC-FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__